const checklist = {
  layout: {
    login: 'Login',
    logout: 'Logout',
    settings: 'Settings',
    users: 'Users',
    dashboard: 'Dashboard',
    hse: 'HSE',
    checklists: 'Checklists',
    userRoles: 'User Roles',
    forms: 'Forms',
    properties: 'Properties',
    sharePoint: 'Sharepoint',
    recentActivities: 'Recent Activities',
    recentDocuments: 'Recent Documents',
    sharepointCredential: 'Sharepoint Credential',
    crm: 'CRM',
    building: 'Building',
    equipment: 'Equipment',
    project: 'Project',
    hours: 'Time Management',
    products: 'Products',
    reports: 'Reports',
    hourreports: 'Hour Reports',
    standard: 'Standard',
    absence: 'Absence',
    unimicroreport: 'UniMicroReport',
    order: 'Orders',
    suppliers: 'Suppliers',
    productGroups: 'Product Groups',
    customers: 'Customers',
    priority: 'Priority',
    groups: 'Groups',
    departments: 'Departments',
    industries: 'Industries',
    shipment: 'Shipments',
    worktypes: 'Worktypes',
    documents: 'Documents',
    timer: 'Timer',
    absencetypes: 'Absence types',
    orderType: 'Order Type',
    uniMicroSettings: 'UniMicro Settings',
    uniMicro: 'UniMicro',
    uniMicroVal: 'UniMicro value',
    template: 'Template'
  },
  login: {
    language: 'Language',
    back: 'Back',
    userName: 'Username',
    password: 'Password',
    authFailed: 'Authentication failed !',
    enterUserName: 'Enter User Name',
    enterPassword: 'Enter Password',
    enterConfirmPassword: 'Confirm Your Password',
    resetNow: 'Reset Now',
    invalidPassword: 'Invalid Password',
    unauthorizedMsg: 'Authentication failed!',
    forgotPassword: 'Forgot Password',
    backToLogin: 'Back to Login',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    setPassowrd: 'Set new password',
    passwordMatch: 'Password doesn\'t match',
    mailNotFound: 'Email not found',
    passwordSaveMsg: 'Password saved successfully'
  },
  customer: {
    name: 'Name',
    customer: 'Customer',
    customerName: 'Customer name',
    address: 'Address',
    addresses: 'Addresses',
    country: 'Country',
    post: 'Post',
    zip: 'Zip',
    city: 'City',
    buildings: 'Buildings',
    municipality: 'Municipality',
    phone: 'Phone',
    email: 'Email',
    web: 'Web',
    website: 'Website',
    organizationNumber: 'Organization number',
    description: 'Description',
    addCustomer: 'Add Customer',
    updateCustomer: 'Update Customer',
    contacts: 'Contacts',
    contact: 'Contact',
    searchForCustomer: 'Search for customers',
    searchForContact: 'Search for contact',
    addContact: 'Add Contact',
    updateContact: 'Update Contact',
    telephone: 'Telephone',
    mobile: 'Mobilephone',
    jobTitle: 'Job title',
    addAddress: 'Add Address',
    updateAddress: 'Update Address',
    postbox: 'Post box',
    postCode: 'Post code',
    latitude: 'Latitude',
    longitude: 'Longitude',
    isStandard: 'Is standard',
    receiveCertificate: 'Receive Certificate',
    mobilePhone: 'Mobilephone',
    note: 'Note',
    headoffice: 'HeadOffice',
    details: 'Details',
    Address: 'Address',
    isCustomer: 'Is Customer',
    isSupplier: 'Is Supplier',
    visit: 'Visit',
    delivery: 'Delivery',
    invoice: 'Invoice',
    paymentTerm1: '10 days',
    paymentTerm2: '15 days',
    paymentTerm3: '30 days',
    sharepointLink: 'Sharepoint link',
    sharepointId: 'Sharepoint id',
    paymentMethod: 'Payment Method',
    hoursDiscountRate: 'Hours discount rate',
    supplyDiscountRate: 'Supply discount rate',
    company: 'Company',
    businessAddress: 'Business Address',
    billingAddress: 'Billing  Address',
    shippingAddress: 'Shipping Address',
    contactAddress: 'Contact Address',
    invoiceTo: 'Invoice to',
    postalAddress: 'Postal Address',
    visitingAddress: 'Visiting Address',
    pdfDownload: 'PDF Download',
    pdfEmail: 'PDF on Email'
  },
  common: {
    required: 'Required',
    refresh: 'Refresh',
    name: 'Name',
    selected: 'Selected',
    english: 'English',
    norwegian: 'Norwegian',
    save: 'Save',
    send: 'Send',
    edit: 'Edit',
    cancel: 'Cancel',
    update: 'Update',
    delete: 'Delete',
    akonto: 'Akonto',
    updateAndClose: 'Update & Close',
    close: 'Close',
    new: 'New',
    open: 'Open',
    isActive: 'Is active',
    isDefault: 'Is default',
    isBillable: 'Is billable',
    addNew: 'Add new',
    savedSuccess: 'Saved successfully!',
    addedSucess: 'Added successfully !',
    updatedSuccess: 'Updated successfully !',
    uploadedSuccess: 'Uploaded successfully !',
    deleteSuccess: 'Deleted successfully !',
    backToList: 'Back To List',
    search: 'Search',
    globalSearch: 'Search globally...',
    yes: 'Yes',
    no: 'No',
    deleteMsg: 'Deleted Successfully',
    loadingMsg: 'Loading, Please wait',
    deleteConfirm: 'Delete Confirm',
    areYouSure: 'Are you sure you want to delete ?',
    sureLockMonth: 'Are you sure to lock month ?',
    lockMonthTitle: 'Confirm Month Lock',
    sureUnLockMonth: 'Are you sure to unlock month ?',
    unlockMonthTitle: 'Confirm Month Unlock',
    lockedSuccess: 'Month locked successfully',
    unlockedSuccess: 'Month Unlocked successfully',
    validationIssue: 'Please check the required fields!',
    noResults: 'No results found !',
    position: 'Position',
    changedPassword: 'Password Changed Successfully',
    invalidEmail: 'Invalid Email',
    invalidNumber: 'Invalid Number',
    noRecords: 'No Records Found!',
    ok: 'Ok',
    date: 'Date',
    comments: 'Comments',
    status: 'Status',
    description: 'Description',
    others: 'Others',
    total: 'Total',
    actions: 'Actions',
    color: 'Color',
    year: 'Year',
    month: 'Month',
    responsible: 'Responsible',
    attachments: 'Attachments',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    download: 'Download',
    details: 'Details',
    report: 'Report',
    updatedOn: 'Updated on',
    searchResults: 'Search Results',
    applicationResult: 'Application Results',
    sharepointResult: 'Sharepoint Documents',
    firstname: 'Firstname',
    lastname: 'Lastname',
    type: 'Type',
    sendRequest: 'Send Request',
    typeHere: 'Type here',
    clear: 'Clear',
    invalidMobileno: 'Mobile/Telephone is not valid',
    invalidPostalCode: 'Postal code is invalid',
    columns: 'Columns',
    draft: 'Draft',
    toBeAssigned: 'To be assigned',
    underWork: 'Under Work',
    billing: 'Billing',
    completed: 'Completed',
    relate: 'Relate',
    relateBuilding: 'Relate building',
    relateEquipment: 'Relate equipment',
    select: 'Select',
    multiEmailHint: 'NOTE: Please use comma(,) to add multiple email ids',
    add: 'Add',
    confirm: 'Confirmation',
    confirmType: 'Do you want add new type',
    confirmModel: 'Do you want add new model',
    confirmFabricate: 'Do you want add new fabricate',
    notAvailableMsg: 'Not available in list',
    selectView: 'Select View',
    ownerHistory: 'Owner History',
    changedOn: 'Changed on',
    notificationMsg: 'You are not delivered minimum hours for this week',
    create: 'Create',
    existing: 'Existing',
    monthLocked: 'Month Locked',
    common: 'Common',
    warning: 'Warning !',
    changes_saved: 'You haven\'t saved your changes',
    are_you_navigate: 'Are you sure want to navigate ?',
    back: 'Back',
    maxCharacters: 'Max {charCount} characters',
    scanEquipment: 'Scan Equipment',
    saveClose: 'Save & Close',
    showmore:'Show more',
    showless:'Show less'
  },
  dashboard: {
    new: 'New',
    inProgress: 'In progress',
    cancelled: 'Cancelled',
    closed: 'Closed',
    day: 'Day',
    today: 'Today',
    monthly: 'Month',
    annual: 'Annual',
    noOfTickets: 'No. of Tickets',
    byDay: 'By day',
    byWeek: 'By week',
    byMonth: 'By month',
    byYear: 'By year',
    totalCustomers: 'Total Customers',
    totalOrders: 'Total Orders',
    totalHours: 'Total Hours',
    testWidget: 'Test Widget'
  },
  checklist: {
    label: 'Label',
    placeholder: 'Placeholder',
    gettingChecklists: 'Getting checklists...',
    module: 'Module',
    selectModule: 'Select module',
    selectStatus: 'Select status',
    advanced: 'Advanced',
    drag: 'Drag',
    dragProps: 'Drag the properties',
    standardProps: 'Standard properties',
    advancedProps: 'Advanced properties',
    favourite: 'Favourite templates',
    not_done : 'Cannot allow usage when at last one point requires repair.'
  },
  user: {
    update: 'Update user',
    add: 'Add user',
    email: 'Email',
    isAdmin: 'Is Admin',
    group: 'Group',
    sendNotification: 'Would like to get notification?',
    firstName: 'First name',
    lastName: 'Last name',
    fullName: 'Full name',
    role: 'Role',
    department: 'Department',
    pin: 'PIN',
    phone: 'Phone number',
    extEmployeeNumber: 'Ext. Employee Number',
    extEmployeeName: 'Ext. Employee Name'
  },
  userRole: {
    administrator: 'Administrator',
    office: 'Office',
    technician: 'Technician'
  },
  sharepointSettings: {
    baseUrl: 'Base url',
    siteUrl: 'Site url',
    listName: 'List name',
    loadFolders: 'Load folders',
    loadList: 'Load List',
    propertiesConfig: 'Properties Configuration',
    contentType: 'Content Type',
    selectChemicalBase: 'Select chemical base',
    selectEquipmentBase: 'Select equipment base',
    selectExpertiseBase: 'Select expertise base'
  },
  settings: {
    addShipment: 'Add Customer Shipment',
    updateShipment: 'Update Customer Shipment',
    addCustomerPriority: 'Add Customer Priority',
    updateCustomerPriority: 'Update Customer Priority',
    addIndustry: 'Add Customer Industry',
    updateIndustry: 'Update Customer Industry',
    addBuilding: 'Add Building',
    updateBuilding: 'Update Building',
    shortName: 'Short name',
    addFacility: 'Add facilities address',
    updateFacility: 'Update facilities address',
    addProductGroup: 'Add Product Group',
    updateProductGroup: 'Update Product Group',
    equipmentType: 'Equipment Type',
    refrigerant: 'Refrigerant',
    addEquipmentType: 'Add Equipment Type',
    updateEquipmentType: 'Update Equipment Type',
    addRefrigerant: 'Add Refrigerant',
    updateRefrigerant: 'Update Refrigerant',
    addOrderType: 'Add Order Type',
    updateOrderType: 'Update Order Type',
    order: 'Order',
    equipmentModel: 'Equipment Model',
    equipmentFabricate: 'Equipment Fabricate',
    equipmentDocuments: 'Equipment Documents',
    industry: 'Industry',
    generalSettings: 'General Settings',
    lockMsg: 'Lock it on',
    monthMsg: 'Every month',
    minimumHours: 'Minimum hours',
    organizationNumber: 'Organization number',
    sellerIndentificationCode: 'Seller identification code',
    companyName: 'Company name',
    accountNo: 'Account number',
    ibanBban: 'IBAN/BBAN',
    branchName: 'Branch name',
    vismaClientNumber: 'Visma client number',
    streetName: 'Street name',
    countryIdentityCode: 'Country identification code',
    contactName: 'Contact name',
    contactTelephone: 'Contact telephone',
    contactEmail: 'Contact Email'
  },
  department: {
    add: 'Add Department',
    update: 'Update Department'
  },
  group: {
    add: 'Add Group',
    update: 'Update Group'
  },
  order: {
    createOrder: 'Create Order',
    updateOrder: 'Update Order',
    number: 'Number',
    startDate: 'Start Date',
    endDate: 'End Date',
    note: 'Note',
    paymentTerm: 'Payment Term',
    deadlineDate: 'Deadline Date',
    bas: 'Bas',
    manager: 'Manager',
    customer: 'Customer',
    hours: 'Hours',
    addActivity: 'Add activity',
    updateActivity: 'Update activity',
    activities: 'Activities',
    breakHour: 'Break time',
    cooling: 'Cooling',
    ventilation: 'Ventilation',
    both: 'Cooling & Ventilation',
    updateOrderType: 'Update Order Type',
    createOrderType: 'Create Order Type',
    headingMax: 'Heading (Max 30)',
    participant: 'Participant',
    tasksPerformed: 'Tasks Performed'
  },
  equipment: {
    equipment: 'Equipment',
    equipments: 'Equipments',
    useAsDefault: 'Use as default',
    machine: 'Equipment Machine',
    createEquipment: 'Create Equipment',
    updateEquipment: 'Update Equipment',
    checklist: 'Checklist',
    building: 'Building',
    barcode: 'Barcode',
    agreementNumber: 'Agreement number',
    fabricate: 'Fabricate',
    warrantyDue: 'Warranty due',
    visitsQtyYear: 'Visits per year',
    hoursPerVisit: 'Hours per visit',
    agreementType: 'Agreement type',
    firstVisit: 'First visit',
    nextVisit: 'Next Visit',
    unitPlacement: 'Unit placement',
    serviceComment: 'Service Comment',
    refrigerantVolume: 'Refrigerant Volume',
    installDate: 'Install Date',
    refrigerantPerformance: 'Cooling Performance',
    heatPerfromance: 'Heat Performance',
    location: 'Location',
    locationInBuilding: 'Location in building',
    purchaseDate: 'Purchase Date',
    warrantyDate: 'Warranty Date',
    responible: 'Responsible',
    vendor: 'Vendor',
    modelNumber: 'Model Number',
    serialNumber: 'Serial Number',
    capacity: 'Capacity',
    plannedCalibration: 'Planned Calibration',
    scrapDate: 'Scrap Date',
    placement: 'Placement',
    equipmentInfo: 'Equipment Info',
    materials: 'Materials',
    warrantyUntil: 'Warranty until',
    installed: 'Installed',
    plannedVisit: 'Planned Visit',
    lastVisit: 'Last visit',
    filters: 'Filters',
    belts: 'Belts',
    airExtract: 'Air Extract',
    airSupply: 'Air Supply',
    from: 'From',
    till: 'To',
    chooseFromList: 'Choose from list',
    scanCode: 'Scan SN/Barcode',
    noEquipment: 'Equipment is not registered, would you like to add it?',
    noBuilding: 'Building is not registered, would you like to add it?',
    plannedFrom: 'Planned from',
    plannedTill: 'Planned to',
    filtersAndBelts: 'Filters and belts'
  },
  products: {
    product: 'Product',
    qtyValue: 'Qty',
    createProduct: 'Create Product',
    updateProduct: 'Update Product',
    productCategories: 'Product Categories',
    createProductCategories: 'Create Product category',
    updateProductCategories: 'Update Product category',
    productDiscounts: 'Product Discounts',
    createproductDiscounts: 'Create Product Discounts',
    updateProductDiscount: 'Update Product Discounts',
    productTax: 'Product Tax',
    createProductTax: 'Create product tax',
    updateProductTax: 'Update product tax',
    createProductType: 'Create Product type',
    updateProductType: 'Update Product type',
    productType: 'Product Type',
    productUnits: 'Product Units',
    createProductUnit: 'Create Product Unit',
    updateProductUnit: 'Update Product Unit',
    model: 'Model',
    skucode: 'Sku code',
    retailPriceIncVat: 'Retail Price Inc VAT',
    discount: 'Discount',
    netPrice: 'Net Price',
    unit: 'Unit',
    type: 'Type',
    category: 'Category',
    manufacturer: 'Manufacturer',
    weight: 'Weight',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    minQty: 'Min qty',
    keyword: 'Keyword',
    metaTitle: 'Meta title',
    metaDescription: 'Meta Description',
    metaKeyword: 'Meta Keyword',
    tag: 'Tag',
    packagingNo: 'Packaging No',
    alternativeNumber: 'Alternative number',
    percentage: 'Percentage',
    price: 'Price',
    qty: 'Quantity',
    noDiscountFound: 'No Discount Found',
    dateused: 'Date used',
    prices: 'Prices',
    noPricesFound: 'No Prices Found',
    costPrice: 'Cost Price',
    grossMargin: 'Gross Margin',
    vat: 'VAT',
    salesPrice: 'Sales Price',
    validFrom: 'Valid Form',
    packageQty: 'Package Qty',
    productGroup: 'Group',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    export: 'Export',
    import: 'Import',
    chooseFiles: 'Choose Files',
    importProducts: 'Import Products',
    importSuccess: 'Import is started!, please check for update in few seconds'
  },
  timer: {
    user: 'User',
    order: 'Order',
    loggHours: 'Logg Hours',
    hourApproval: 'Approval Process',
    deliver: 'Deliver',
    approve: 'Approve',
    notApprove: 'Not Approve',
    approved: 'Approved',
    delivered: 'Delivered',
    notDelivered: 'Not Delivered',
    notApprovedMsg: 'Not approved',
    approveHours: 'Approve Hours',
    approvedHours: 'Approved Hours',
    notApprovedHours: 'Not Approved Hours',
    selectEntries: 'No Entries Selected',
    editHours: ' Edit Hour',
    addComments: 'Add Comments',
    employee: 'Employee',
    comments: 'Comments',
    amount: 'Amount',
    notApproved: 'Not approved comments',
    totalHours: 'Total Hours',
    noHours: 'No hours found for deliver !',
    deliveredSuccessfully: 'Delivered Successfully !',
    go: 'Go',
    addHours: 'Add Hour',
    activity: 'Activity',
    workType: 'Work type',
    startTime: 'Start time',
    endTime: 'End time',
    invalidHours: 'Invalid hours',
    lockMonth: 'Lock month',
    forAll: 'For all',
    forUsers: 'For Users',
    absencetype: 'Absence type',
    cost: 'Cost',
    toInvoice: 'To invoice'
  },
  reports: {
    perOrder: 'Per Order',
    perEmployee: 'Per Employee',
    perCustomer: 'Per Customer',
    selectEmployees: 'Select Employees',
    selectOrders: 'Select Orders',
    selectUsers: 'Select Users',
    selectProducts: 'Select Product',
    selectCustomers: 'Select Customers',
    runReport: 'Run Report',
    filterActions: 'Filter Actions',
    selectStatus: 'Select Status',
    onlySum: 'Show Only Sum',
    onlyPdf: 'Only PDF',
    onlyXlsx: 'Only Xslx',
    onlyEstimation: 'Show Only Estimation',
    both: 'Both',
    sendReport: 'Send Report',
    emailNote: 'Please use comma(,) to add multiple email ids',
    fileType: 'File Type',
    displayMsg: 'No records',
    employeeName: 'Employee Name',
    sum: 'Sum',
    sentSuccess: 'Sent Successfully',
    sumTimer: 'Sum Timer',
    estimation: 'Estimation',
    progress: 'Progress',
    userCost: 'User Cost',
    usedQty: 'Used Qty',
    usedBy: 'Used By',
    usedDate: 'Used Date'
  },
  worktype: {
    add: 'Add Worktype',
    update: 'Update Worktype',
    extSalaryCode: 'Ext. Salary Code',
    extAccountNo: 'Ext. Account No'
  },
  absencetype: {
    add: 'Add Absencetype',
    update: 'Update Absencetype'
  },
  sharePoint: {
    config: 'SharePoint Configurations',
    baseUrl: 'Base url',
    siteUrl: 'Site url',
    listName: 'List name',
    loadFolders: 'Load folders',
    loadList: 'Load List',
    propertiesConfig: 'Properties Configuration',
    contentType: 'Content Type',
    rootFolder: 'Select CRM Folder',
    sharepointCredential: 'SharePoint Credentials',
    commonCred: 'Common Credential',
    individualCred: 'Individual Credential',
    proceed: 'Proceed'
  },
  unimicro: {
    pageTitle: 'Unimicro Setting',
    customerNumber: 'Customer number',
    systemMailAddress: 'System mail address',
    csvDelimiter: 'CSV Delimiter',
    createReport: 'Create report',
    updatedBy: 'Updated by',
    updatedOn: 'Updated on',
    preview: 'Preview',
    sendReport: 'Send Report',
    employeeNumber: 'Employee number',
    salaryCode: 'Salary code',
    rate: 'Rate',
    accountNumber: 'UniMicro account number',
    supplierNumber: 'Supplier number',
    payGrade: 'Pay grade',
    organizationNumber: 'Organization number',
    entryNo: 'Entry no',
    dim: 'Dim',
    numberToInvoice: 'Number to invoice',
    retailPrice: 'Retail price',
    orderNumber: 'Order number',
    kommunenr: 'Kommunenr',
    createdBy: 'Created by',
    createdOn: 'Created on',
    datesMandatory: 'Dates must be selected',
    pending: 'Pending',
    sent: 'Sent'
  },
  documents: {
    hseSystem: 'HSE-SYSTEM',
    uploadDocument: 'Upload Document',
    gettingFolders: 'Loading... Please wait...',
    noDocuments: 'NO DOCUMENTS FOUND!',
    noFolders: 'NO FOLDERS FOUND!',
    createNew: 'Create folder',
    editName: 'Edit folder',
    deleteFolder: 'Delete folder',
    upload: 'Upload',
    create: 'Create',
    folderName: 'Folder name',
    files: 'Files',
    noResponsible: '*no responsible',
    noDescription: '*no description',
    updateMetaData: 'Update Meta Data',
    openNewTab: 'Open in new Tab',
    editMeta: 'Edit Meta',
    versionHistory: 'Version History',
    versionLabel: 'Version Label',
    size: 'Size',
    modifiedBy: 'Modified By',
    modifiedOn: 'Modified On',
    title: 'Title',
    searchFound: 'Search Results : Found',
    versioningDocuments: 'Versioning documents'
  },
  template: {
    add: 'Add Template',
    update: 'Update Template',
    templates: 'Templates'
  },
  invoice: {
    yourReference: 'Your Reference',
    yourContact: 'Your Contact',
    ourReference: 'Our Reference',
    invoicedDate: 'Invoiced Date',
    duedate: 'Due Date',
    invoicing: 'Invoicing',
    completedDate: 'Completed Date',
    rbt: 'Rbt',
    sum: 'Sum',
    sumeksMva: 'Eks VAT',
    MVA: 'MVA',
    roundDown: 'Round Down',
    invoiceTotal: 'Invoice total incl',
    invoicePreview: 'Invoice Preview',
    saveAs: 'Save As',
    saveAsDraft: 'Save as Draft',
    saveAndEmail: 'Save and Email',
    saveAndDownloadPDF: 'Save and download PDF',
    addInvoice: 'Add Invoice',
    updateInvoice: 'Update Invoice',
    createCreditNote: 'Create Credit Note',
    updateCreditNote: 'Update Credit Note',
    pmtTerms: 'PMT Term',
    saveAndUseEHF: 'Save and use EHF (Auto invoice)',
    days: 'Days',
    exportToVisma: 'Export To Visma',
    showAll: 'Show all',
    groupByCustomer: 'Group by customer',
    exported: 'Exported',
    totalSum: 'Total sum',
    cantDelete: 'Invoice can\'t be deleted!',
    toBeExported: 'To be exported',
    invoiceNumber: 'Invoice number',
    basePrice: 'Base price',
    priceIncVat: 'Inc VAT',
    invoiceCreatedBy: 'Invoice Created By',
    creditNoteCreatedBy: 'Credit note created by',
    createdFrom: 'Created from',
    creditConfirm: 'Are you sure you want to create credit note ?',
    confirmation: 'Confirmation',
    searchProduct: 'Search Product',
    creditNote: 'Credit note',
    hoursConfirm: 'There are hours that have not been approved yet, would you like to continue to create the invoice ?',
    productsConfirm: 'No products has been added, would you like to continue to create the invoice?',
    hoursProducts: 'Do you want to include hours & products from order ?',
    qty: 'Qty',
    hoursProductAvail: 'Hours and products should be available for invoicing?',
    pressHold: '* Press and Hold <code>Ctrl</code> key to select more'
  },
  app: {
    title: 'Avalia CheckList Builder',
    avaliaForm: 'Avalia Form',
    confirmation: 'Confirmation!',
    sureToLogout: 'Are you sure want to logout?',
    yes: 'Yes',
    no: 'No',
    notApplicable: 'Not Applicable',
    sureToDelete: 'Are you sure want to delete?',
    warning: 'Warning!',
    changesNotSaved: 'You haven\'t saved your changes',
    sureToNavigate: 'Are you sure want to navigate ?',
    english: 'English',
    norwegian: 'Norwegian',
    login: 'Login',
    authFails: 'Authentication Failed!',
    validationFailed: 'Please check mandatory fields',
    deleteSuccess: 'Deleted Successfully!',
    updateSuccess: 'Updated Successfully!',
    saveSuccess: 'Saved Successfully!',
    search: 'Search',
    save: 'Save',
    update: 'Update',
    back: 'Back',
    close: 'Close',
    updateClose: 'Update & Close',
    reset: 'Reset',
    only5rowsAllowed: 'Only 5 rows allowed'
  },
  props: {
    new: 'New',
    name: 'Name',
    description: 'Description',
    label: 'Label',
    type: 'Type',
    placeholder: 'Placeholder',
    isActive: 'Is Active',
    actions: 'Actions',
    value: 'Value',
    options: 'Options',
    addProps: 'Add Properties',
    updateProps: 'Update Properties',
    formAttributes: 'FORM ATTRIBUTES',
    useAsTitle: 'Use as title',
    validation: 'Validation',
    isMultiSelect: 'Is multiselect',
    defaultValue: 'Default Value',
    enterValue: 'Enter one of the values from option',
    isApi: 'Is API',
    apiUrl: 'API URL',
    objectName: 'Object name',
    columns: 'Columns',
    gridColumns: 'Grid Columns',
    question: 'Question ?',
    link: 'Html',
    enterTitleOfColumn: 'Enter Title Of Each Columns',
    loadingGrid: 'Loading grids...',
    favourite: 'Favourite',
    customProperties: 'Custom Properties',
    enterTitle: 'Enter Title',
    rows: 'Rows',
    preparingFields: 'Preparing Fields',
    dragging: 'Dragging...',
    fontSize: 'Font size',
    preview: 'Preview',
    enterTitleAndWidthOfColumn: 'Enter Title and Width Of Each Columns',
    totalWidth: 'Total Width',
    radiobox: 'RadioBox',
    checkbox: 'CheckBox',
    select: 'Select',
    string: 'Text',
    number: 'Number',
    properties: 'Properties',
    hideComments: 'Hide Comments',
    hideAttachments: 'Hide Attachments',
    conditional: 'Conditional',
    true: 'true',
    false: 'false',
    defaultValueKeyword: 'Default Value by keyword',
    logical: 'Logical'
  },
  form: {
    updateFormProps: 'Update Form Properties',
    addNewForm: 'Add new form',
    selectGroup: 'Select group',
    addHeader: 'Add Header',
    addFooter: 'Add Footer',
    formProps: 'FORM PROPERTIES',
    allCaughtUp: 'All caught up!',
    dropFields: 'Drop the fields here!',
    addHtmlContent: 'ADD HTML CONTENT',
    forHeader: 'FOR HEADER',
    forFooter: 'FOR FOOTER',
    comments: 'Comments',
    attachments: 'Attachments',
    sureToCloneFields: 'Are you sure want to clone fields?',
    documents: 'Documents',
    document: 'Document',
    updateDocument: 'Update Document',
    addGroup: 'Add Group',
    updateGroup: 'Update Group',
    date: 'Date',
    signature: 'Signature',
    notes: 'Notes',
    showWidthFieldAboveHeader: 'Show width field above header',
    showField: 'Show Field'
  },
  facilities: {
    address: 'Facilities address',
    search: 'Search for Facilities address'
  }
}


export default checklist;